var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsTachometersvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 4C6.81926 4 2.33326 8.486 2.33326 14C2.33196 15.5434 2.69189 17.0656 3.38426 18.445C3.55426 18.785 3.90026 19 4.27926 19H20.3863C20.7653 19 21.1123 18.785 21.2823 18.445C21.9746 17.0656 22.3346 15.5434 22.3333 14C22.3333 8.486 17.8473 4 12.3333 4ZM17.3553 9.022L13.3933 15.06C13.283 15.2283 13.1407 15.3733 12.9744 15.4865C12.8081 15.5998 12.621 15.6791 12.424 15.72C12.227 15.7608 12.0239 15.7624 11.8262 15.7247C11.6286 15.687 11.4403 15.6106 11.2723 15.5C11.0595 15.3609 10.8848 15.171 10.7639 14.9474C10.643 14.7238 10.5796 14.4737 10.5796 14.2195C10.5796 13.9653 10.643 13.7152 10.7639 13.4916C10.8848 13.268 11.0595 13.0781 11.2723 12.939L17.3103 8.977C17.3176 8.97247 17.3264 8.97097 17.3348 8.97284C17.3432 8.97471 17.3505 8.97979 17.3553 8.987C17.3584 8.99229 17.3601 8.99834 17.3601 9.0045C17.3601 9.01067 17.3584 9.01671 17.3553 9.022Z",
    fill: "#20A8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsTachometersvg);
export default __webpack_public_path__ + "static/media/bxs-tachometer.svg.0f3897e4cbc81fbbe4948470aebdd043.svg";
export { ForwardRef as ReactComponent };